// extracted by mini-css-extract-plugin
export default {"cls1":"BankLookupBody-BankDetails_cls1__H63aC","cls2":"BankLookupBody-BankDetails_cls2__rEJCB BankLookupBody-BankDetails_cls1__H63aC"};